<template>
  <div
    :class="computedClasses"
    class="page"
  >
    <no-ssr>
      <cart-add-popup
        v-if="cartAddPopup.node.title"
        v-model="cartAddPopup.mode"
        :node="cartAddPopup.node"
        :message="cartAddPopup.message"
      />

      <site-noticebar
        v-if="noticebarEnabled"
        v-bind="salesStyle"
        :preview-mode="noticebarInPreviewMode"
      />

      <sitegate
        v-if="sitegateEnabled"
        :gate="siteGate"
      />
      <age-gate
        v-else-if="showAgeGate"
        :require-birthdate="false"
      />
    </no-ssr>

    <page-top />

    <div
      id="main-wrap"
      :class="{'active': menuDisplayed }"
      class="main-wrap"
    >
      <transition
        v-if="showmobilenavcontent"
        name="menu-fade"
      >
        <component
          :is="mobilenavcontent"
          v-if="menuDisplayed"
        />
      </transition>
      <div
        :class="mobileMenuDisplayPort"
        class="page-overlay"
        @click.prevent="triggerHideMobileMenuButton"
      />
      <div class="content-wrap">
        <router-view
          v-if="!errorCode"
          v-bind="ssrBlockedProps"
        />
        <error-page
          v-else
          :code="errorCode"
        />
      </div>

      <page-bottom v-if="isSSR" />
      <component
        :is="pagebottomcomponent"
        v-if="pagebottomcomponent && !isSSR"
      />
    </div>
    <below-the-fold />
    <cookiebar v-if="cookiebarEnabled && !isSSR" />
  </div>
</template>

<script>
import applogger from '@applogger'
import 'intersection-observer'
import belowTheFold from './below-the-fold.vue'
import throttle from 'lodash/throttle'

export default {
  name: 'main-wrap',
  components: { belowTheFold },
  props: {
    classes: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function() {
    return {
      observer: null,
      pagebottomcomponent: false,
      menuDisplayed: false,
      mobileMenuDisplayPort: 'd-block d-lg-none',
      // helpId: null,
      cachedHasHeader: false,
      salesStyle: {
        salesBarPaddingStyle: '2', // vertical paddings
        salesBarCloseable: true, // allows the sales bar to be dismissed
        modalContentDirection: 'row', // modal row or column
        modalContentDesktopPosition: 'right', // if content direction is row this will be displayed and affect the display on desktop,  adjusts positoin of the form or main content left or right
        modalSize: 'xl' // xl or lg modal sizes, we don't recommended to go smaller than lg for row based modals
      },
      cartAddPopup: {
        popupMode: null,
        node: {},
        message: ''
      }
    }
  },
  asyncComponents: ['page-top'],
  computed: {
    noticebarInPreviewMode() {
      return Object.keys(this.$route.meta).includes('previewMode') ? this.$route.meta.previewMode : false
    },
    siteGate() {
      if (this.$route.query['account-activated'] && this.$store.state.registry.isUV()) {
        if (this.$store.getters['sitegate/accountActivationStatus'] === 'success') return 'account-activation-success'
        return 'account-activation-error'
      }
      return this.$store.getters['sitegate/initialLoadGate']
    },
    cookiebarEnabled() {
      return this.$store.state.registry.getFeature('cookiebar')
    },
    sitegateEnabled() {
      if (!this.$store.state.registry.getFeature('sitegate')) return false
      if (this.$route.query['account-activated'] && this.$store.state.registry.isUV()) {
        const status = this.$store.getters['sitegate/accountActivationStatus']
        if (status === 'pending') return false
      }

      return true
    },
    noticebarEnabled() {
      const featureEnabled = this.$store.state.registry.getFeature('noticebar')
      const settings = this.$store.getters['noticebar/settings']
      const settingsEnabled = (settings) ? settings.enabled : false

      return featureEnabled && settingsEnabled
    },
    ssrBlockedProps() {
      return (Object.keys(this.$route.meta).includes('noSSR')) ? this.$route.meta.noSSR : {}
    },
    ageGateComponent: function() {
      return this.configurationSettings.type
    },
    showmobilenavcontent() {
      return (this.$store.getters.getModuleSetting('theme', 'mobile-nav', 'mobile-menu') !== 'mobile-menu')
    },
    mobilenavcontent() {
      const version = this.$store.getters.getModuleSetting('theme', 'mobile-nav', 'mobile-menu')
      return `mobile-nav-content-${version}`
    },
    showAgeGate() {
      return this.$store.state.registry.getFeature('age-gate') && !this.$store.state.registry.getFeature('sitegate')
    },
    isSSR: function() {
      return this.$ssrContext !== undefined
    },
    computedClasses() {
      const classArr = this.classes.split(' ')
      if (this.hasHeader) {
        classArr.push('has-header')
      }
      else {
        classArr.push('no-header')
      }
      if (this.menuDisplayed) {
        classArr.push('has-menu-displayed')
      }
      else {
        classArr.push('no-menu-displayed')
      }

      if (this.$ssrContext !== undefined) {
        classArr.push('animations-disabled')
      }

      return classArr.join(' ')
    },
    loggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
    helpModalVisible: {
      get() {
        return !!this.helpId
      },
      set(val) {
        if (!val) {
          this.helpId = null
        }
      }
    },
    hasHeader() {
      if (!this.$store.state.progressLoaderState) {
        this.cachedHasHeader = this.$store.state.pageSettings.hasHeader
      }
      return this.cachedHasHeader
    },
    errorCode() {
      return this.$store.state.pageSettings.error || false
    },
    routeKey() {
      return this.$route.currentRoute
    }
  },
  watch: {
    $route(to, from) {
      this.$eventHub.$emit('hideMobileMenu')
    }
  },
  created() {
    if (this.$store.getters.registryFeature('sitegate')) {
      this.$store.dispatch('sitegate/init', { payload: this.$route.query, eventHub: this.$eventHub })
    }
    if (this.$store.getters.registryFeature('noticebar')) {
      this.$store.dispatch('noticebar/init')
    }
    if (this.$store.getters.registryFeature('cookiebar')) {
      this.$store.dispatch('cookiebar/init')
    }

    this.$eventHub.$on('hideMobileMenu', this.hideMobileMenu)
    this.$eventHub.$on('showMobileMenu', this.showMobileMenu)
    this.$eventHub.$on('logoutComplete', this.logoutRedirect)
    // this.$eventHub.$on('activateContextHelp', this.showContextHelp)
    // this.$eventHub.$on('deactivateContextHelp', this.hideContextHelp)
    this.$eventHub.$on('pageNotFound', this.pageNotFoundHandler)
    this.$eventHub.$on('showHelp', this.showHelp)
    this.$eventHub.$on('hideHelp', this.hideHelp)
    this.$eventHub.$on('productCartAdd', this.handleProductCartAdd)
    this.$eventHub.$on('observeElement', this.observeElement)
    this.$eventHub.$on('unobserveElement', this.unobserveElement)
    this.$eventHub.$on('resetSomnambulistOrders', () => this.$store.dispatch('memberPortal/loadSomnambulistOrders'))
  },
  mounted() {
    const instance = this
    let logoutPending = false
    let timer = null

    const logout = throttle(() => {
      instance.$eventHub.$emit('showProgressLoader')

      // Tell components that a logout has occurred so that they can clean up themselves before the AuthTokens are removed from the store.
      instance.$store.dispatch('user/logout')
        .then(() => {
          applogger.info('Logout Successful')
          instance.$eventHub.$emit('logoutComplete')
          instance.$eventHub.$emit('hideProgressLoader')
          instance.$eventHub.$emit('statusMessage', { type: 'success', title: 'Logout Successful!', text: 'Your logout attempt succeeded.', showClose: false, timeout: 3500 })
        })
        .catch((error) => {
          instance.$eventHub.$emit('hideProgressLoader')
          instance.$eventHub.$emit('statusMessage', { type: 'error', title: 'Logout Failed!', text: error.message, showClose: true })
          throw error
        })
    }, 5000, { leading: true, trailing: false })

    const LogoutHandler = (evt) => {
      if (typeof event.getModifierState !== 'function') {
        return
      }
      if (logoutPending && evt.key === 'X' && event.getModifierState('Control') && event.getModifierState('Shift')) {
        if (timer) {
          clearTimeout(timer)
        }
        applogger.info('Logout Keyboard Shortcut triggered.')
        logoutPending = false
        removeLogoutEventListener()
        instance.$eventHub.$emit('logout')
      }
      else if (evt.key === 'L' && event.getModifierState('Control') && event.getModifierState('Shift')) {
        logoutPending = true
        applogger.info('Logout Keyboard Shortcut pending.')

        timer = setTimeout(() => {
          applogger.info('Logout Keyboard Shortcut expired.')
          logoutPending = false
        }, 1000)
      }
    }
    const addLogoutEventListener = () => {
      window.addEventListener('keyup', LogoutHandler)
      applogger.info('Logout Keyboard Event Listener added.')
    }

    const removeLogoutEventListener = () => {
      if (timer) {
        clearTimeout(timer)
      }
      window.removeEventListener('keyup', LogoutHandler)
      applogger.info('Logout Keyboard Event Listener removed.')
    }
    const LoginHandler = (evt) => {
      if (evt.key === 'L' && event.getModifierState('Control') && event.getModifierState('Shift')) {
        this.$eventHub.$emit('showLoginModal')
      }
    }
    const addLoginEventListener = throttle(() => {
      window.addEventListener('keyup', LoginHandler)
      console.debug('Login Popup Keyboard Event Listener added.')
    }, 1500, { leading: true, trailing: false })

    const removeLoginEventListener = throttle(() => {
      window.removeEventListener('keyup', LoginHandler)
      console.debug('Login Popup Keyboard Event Listener removed.')
    }, 1500, { leading: true, trailing: false })

    if (typeof window !== 'undefined') {
      this.$eventHub.$on('logout', logout)

      this.$eventHub.$on('loginComplete', addLogoutEventListener)
      this.$eventHub.$on('loginComplete', removeLoginEventListener)
      this.$eventHub.$on('loginComplete', () => this.$store.dispatch('logRocketIdentify'))

      this.$eventHub.$on('logoutComplete', addLoginEventListener)
      this.$eventHub.$on('logoutComplete', removeLogoutEventListener)
      this.$eventHub.$on('logoutComplete', () => this.$store.dispatch('logRocketIdentify'))

      this.$eventHub.$on('pageError', function(errorCode, errorContent) {
        this.$store.commit('SET_PAGE_SETTING', { key: 'error', value: errorCode })
      }.bind(this))

      if (!this.$store.getters['user/isLoggedIn']) {
        addLoginEventListener()
      }
      if (instance.$store.getters['user/isLoggedIn']) {
        addLogoutEventListener()
      }

      this.$eventHub.$emit('mainWrapMounted')
    }

    setTimeout(() => {
      this.pagebottomcomponent = 'page-bottom'
    }, 2000)

    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: null,
      threshold: this.$store.state.registry.getSiteSetting('observer-threshold', 0.25)
    })
  },
  beforeDestroy() {
    this.observer.disconnect()
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return
        }

        this.observer.unobserve(target)

        setTimeout(() => target.classList.add('element-observed'), this.$store.state.registry.getSiteSetting('observer-delay', 1000))
      })
    },
    observeElement(payload) {
      this.observer.observe(payload)
    },
    unobserveElement(payload) {
      this.observer.unobserve(payload)
    },
    handleProductCartAdd(payload) {
      this.cartAddPopup = payload
    },
    // showHelp(id) {
    //   this.helpId = id
    // },
    // hideHelp() {
    //   this.helpId = null
    // },
    pageNotFoundHandler() {
      this.$store.dispatch('hideProgressLoader')
    },
    triggerHideMobileMenuButton: function() {
      this.$eventHub.$emit('hideMobileMenu')
    },
    logoutRedirect() {
      if (typeof window !== 'undefined' && window.location.pathname !== '/') {
        this.$router.push('/')
      }
    },
    hideMobileMenu: function() {
      this.menuDisplayed = false
    },
    showMobileMenu: function() {
      this.menuDisplayed = true
    }
  }
}
</script>

<style lang='scss'>
@import '~@scss/custom.scss';
@import '~@scss/vincreative-forms.css';
@import '~@scss/base-variables.css';
@import '~@scss/common.scss';
@import '~@scss/project-theme.scss';
@import '~@scss/project-theme-variables.scss';

//menu fade transitions
.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity .5s ease-in-out;
}

.menu-fade-enter,
.menu-fade-leave-to{
  opacity: 0;
}

//page and main warp fixed positions
%fixed {
    position: fixed;
    width:100%;
    height:100%;
}
.page {
  &.absolute-header {
    &.has-menu-displayed {
      @extend %fixed;
    }
    &.no-header {
      .content-wrap {
        margin-top:var(--main-site-header-height);
      }
    }
  }
}
.main-wrap {
  position: relative;
  &.active {
    @extend %fixed;
  }
}
#loginbox {
  .modal-body {
    .btn-primary {
      padding: 20px;
    }
    .invalid-feedback {
      margin-top: 0rem;
    }
    .form-control {
      &.is-valid {
        border-left: 5px solid #42ba5e;
      }
      &.is-invalid {
        border-left: 5px solid #f73e3e;
      }
    }
    form {
      padding:0rem;
    }
  }
}

body {
  overflow-x: hidden;
  //default behaviour so that when a position fixed element appears we don't get reflow
  overflow-y: scroll;
}

.page-overlay {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: $black;
  will-change: opacity;
  @include transition((opacity 0.65s ease-in-out, z-index 0.65s));
}

.active .page-overlay {
  opacity: 0.5;
  z-index: 100;
}

.hot-corner-wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 200px;
  height: 200px;
  z-index: 100;

  .hot-corner {
    transition: ease-in-out all 0.3s;
    border-top-left-radius: 250px;
    right: -200px;
    bottom: -200px;
    width: 100%;
    height: 100%;
    position: absolute;

    a {
      color: #fff;
      position: absolute;
      bottom: 20px;
      right: 50px;
      font-size: 60px;
    }
  }
  &:hover {
    .hot-corner {
      background: #000;
      right: 0;
      bottom: 0;

      &.active {
        background: #37ac6f;
        a {
          color: #fff;
        }
      }
    }
  }
}

.help-system-modal {
  .modal-content {
    .modal-body {
      padding: 0;
    }
  }
}

@keyframes growth {
  to {
    width: 100%;
  }
}
</style>
